import React from 'react';
import { Link } from 'react-router-dom';
import { IconCalendar, IconChevronRight } from '@tabler/icons-react';
import Avatar from '../common/Avatar';
import Button from '../common/Button';
import { PATHS, toPath } from '../../routes/paths';
import { formatDayDateNoComma, formatTime } from '../../utils/date';
import { shortLanguages } from '../../utils/format';

/**
 * public: tap-through card with next available date (pre-login "Our doctors").
 * member: card with next available date + time and a Book button (logged-in "Find a doctor").
 */
export default function DoctorListCard({ doctor, variant = 'public' }) {
  const detail = toPath(PATHS.doctorDetail, { id: doctor.id });
  const next = doctor.nextAvailable;

  if (variant === 'member') {
    return (
      <article className="card doctor-card doctor-card--member">
        <Link to={detail} className="doctor-card__head">
          <Avatar name={doctor.name} src={doctor.photoUrl} />
          <div className="u-grow">
            <h3 className="doctor-card__name">{doctor.name}</h3>
            <p className="doctor-card__meta">{`${doctor.specialty} · ${shortLanguages(doctor.languages)}`}</p>
          </div>
        </Link>
        <div className="doctor-card__foot">
          <div>
            <p className="doctor-card__label">Next available</p>
            <p className="doctor-card__next">
              {next ? `${formatDayDateNoComma(next.date)}, ${formatTime(next.time)}` : 'No slots open'}
            </p>
          </div>
          <Button size="xs" to={toPath(PATHS.book, { doctorId: doctor.id })} disabled={!next}>Book</Button>
        </div>
      </article>
    );
  }

  return (
    <Link to={detail} className="card doctor-card">
      <div className="doctor-card__head">
        <Avatar name={doctor.name} src={doctor.photoUrl} />
        <div className="u-grow">
          <h3 className="doctor-card__name">{doctor.name}</h3>
          <p className="doctor-card__meta">{doctor.specialty}</p>
          <p className="doctor-card__meta">{doctor.languages.join(', ')}</p>
        </div>
        <IconChevronRight size={20} className="list-row__chevron" />
      </div>
      <div className="doctor-card__foot doctor-card__foot--inline">
        <IconCalendar size={18} />
        <span className="u-muted">Next available</span>
        <strong>{next ? formatDayDateNoComma(next.date) : '—'}</strong>
      </div>
    </Link>
  );
}
